import type { NotificationType } from "../../../../common-deprecated/types/CommonTypes";
import { CarConfigConfigureSection } from "../utils/types/SectionTypes";
import { CarConfigConfigureSectionsLbx } from "../utils/types/SectionTypesLbx";
import { useCarConfigLabel } from "../utils/labelUtils";

type getNotificationsToDisplayType = { colours: boolean; upholsteries: boolean; useLbxJourney?: boolean };
type useCarConfigNotificationsType = {
    getNotificationsToDisplay: (props: getNotificationsToDisplayType) => NotificationType[];
};
const useCarConfigNotifications = (): useCarConfigNotificationsType => {
    const [
        carConfigNewColoursAvailableTitleLabel,
        carConfigNewColoursAvailableDescriptionLabel,
        carConfigNewUpholsteriesAvailableTitleLabel,
        carConfigNewUpholsteriesAvailableDescriptionLabel,
        carConfigNewItemsAvailableButton,
    ] = useCarConfigLabel([
        "carConfigNewColoursAvailableTitle",
        "carConfigNewColoursAvailableDescription",
        "carConfigNewUpholsteriesAvailableTitle",
        "carConfigNewUpholsteriesAvailableDescription",
        "carConfigNewItemsAvailableButton",
    ]);

    const getNotificationsToDisplay = (props: getNotificationsToDisplayType): NotificationType[] => {
        const { colours, upholsteries, useLbxJourney = false } = props;
        const notifications: NotificationType[] = [];

        if (colours)
            notifications.push({
                title: carConfigNewColoursAvailableTitleLabel,
                description: carConfigNewColoursAvailableDescriptionLabel,
                action: {
                    targetButton: {
                        text: carConfigNewItemsAvailableButton,
                        target: useLbxJourney
                            ? CarConfigConfigureSectionsLbx.AtmosphereColor
                            : CarConfigConfigureSection.Colour,
                    },
                    closeButton: true,
                },
            });
        if (upholsteries) {
            notifications.push({
                title: carConfigNewUpholsteriesAvailableTitleLabel,
                description: carConfigNewUpholsteriesAvailableDescriptionLabel,
                action: {
                    targetButton: {
                        text: carConfigNewItemsAvailableButton,
                        target: useLbxJourney
                            ? CarConfigConfigureSectionsLbx.AtmosphereUpholstery
                            : CarConfigConfigureSection.Upholstery,
                    },

                    closeButton: true,
                },
            });
        }
        return notifications;
    };

    return { getNotificationsToDisplay };
};

export default useCarConfigNotifications;
